import React, { Component } from 'react';
import { Button, Card, CardActions, CardContent, CardHeader, Icon, IconButton } from '@material-ui/core';
import TableWithoutPagination from '../Table/TableWithoutPagination';
import moment from 'moment'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { downloadInvoice, loadInvoices } from '../../redux/invoices/invoicesActions';
import { OUT_REFUND } from '../../redux/invoices/invoicesConstants';
import { formatAmountToString } from '../../utils';

class MyInvoices extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    columns: [
                        {
                            Header: "Date",
                            id: 'date_invoice',
                            width: 80,
                            accessor: i => moment(i.date_invoice).format("DD/MM/YY"),
                        },
                        {
                            Header: "Numero",
                            id: 'code',
                            width: 120,
                            accessor: "number",
                        },
                        {
                            Header: "Montant TTC",
                            id: 'amount_total',
                            className: 'right',
                            accessor: i => (i.type === OUT_REFUND ? "-" : "")  + formatAmountToString(i.amount_total)
                        },
                    ]
                },
            ]
        }
        
        this.props.loadInvoices(this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.invoices, this.props.tableState.nbTotalResults);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.loadInvoices(this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.invoices, this.props.tableState.nbTotalResults);
    }

    goToInvoices(e) {
        this.props.history.push("/invoices");
        e.stopPropagation();
    }

    downloadInvoice(e, invoice) {
        this.props.downloadInvoice(invoice, this.props.activeUser);

        e.stopPropagation();
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: e => this.downloadInvoice(e, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={this.props.className}>
                <Card className="card without-padding full-height" onClick={this.goToInvoices.bind(this)}>
                    <CardHeader title={"Mes factures"} titleTypographyProps={{ variant: "h6", color: 'primary' }}
                        avatar={<Icon className={classes.iconStyle}>description</Icon>}
                        action={
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />
                    <CardContent className="without-padding">
                        <TableWithoutPagination
                            data={this.props.invoices.filteredAndSortedInvoices}
                            columns={this.state.columns}
                            pageSize={3}
                            minRows={3}
                            sortable={false}
                            getTrProps={this.getTableTrProps.bind(this)}
                        />
                    </CardContent>
                    <CardActions className={classes.cardActions} disableSpacing>
                        <Button variant="contained" size="small" color="secondary" onClick={this.goToInvoices.bind(this)}
                            startIcon={<Icon>arrow_forward</Icon>} className={classes.smallButton}>
                            Voir plus
                    </Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        invoices: state.invoices,
        activeUser: state.activeUser,
        sites: state.sites,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadInvoices: (user, customerSiteId, allSites, invoicesFilters, nbTotalResults) => dispatch(loadInvoices(user, customerSiteId, allSites, invoicesFilters, nbTotalResults)),
        downloadInvoice: (invoice, user) => dispatch(downloadInvoice(invoice, user)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(MyInvoices);
